import React from "react";
import { lang } from "../lang";

// Modal for confirming data wipe
function WipeModal({ isOpen, onConfirm, onCancel, onSaveAll }) {
  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>{lang.wipeModal.heading}</h3>
        <p>{lang.wipeModal.message}</p>
        <div className="modal-actions">
          <button onClick={onSaveAll}>{lang.drawer.saveAll}</button>
          <button onClick={onConfirm}>{lang.wipeModal.confirm}</button>
          <button onClick={onCancel}>{lang.wipeModal.cancel}</button>
        </div>
      </div>
    </div>
  );
}

export default WipeModal;
